import http from '@/biz/http.mjs'

export default {
    read: args => http.get('/pm/oneArchPm', args),
}
